import type { IconSvgObject } from './types';

const JoinBevelIcon: IconSvgObject = [
  ["path", { d: "M2 14.5V2H11V13H22V22H9.5L2 14.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default JoinBevelIcon;
